var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
import { Vue, Component, Watch } from "vue-facing-decorator";
import { Feature, CompaniesClient, SystemsClient, SystemComponentsClient, SystemComponentTreeNodesClient, ComponentLimitsClient, LookupsClient, AlarmsClient, GetComponentLimitListQuery } from "@/app/api/battery-portal-api";
import { Notifier } from "@/common/utils/notifier";
import { HttpHelper } from "@/app/utils/http-helper";
import moment from 'moment';
const companiesClient = new CompaniesClient(window.apiUrl);
const systemsClient = new SystemsClient(window.apiUrl);
const systemComponentsClient = new SystemComponentsClient(window.apiUrl);
const systemComponentTreeNodesClient = new SystemComponentTreeNodesClient(window.apiUrl);
const componentLimitsClient = new ComponentLimitsClient(window.apiUrl);
const lookupsClient = new LookupsClient(window.apiUrl);
const alarmsClient = new AlarmsClient(window.apiUrl);
let ComponentLimitsVue = class ComponentLimitsVue extends Vue {
    constructor() {
        super(...arguments);
        this.working = false;
        this.searchAttempted = false;
        this.companies = [];
        this.systems = [];
        this.strings = [];
        this.components = [];
        this.alarmTypes = [];
        this.measurementTypes = [];
        this.stringStates = [];
        this.query = new GetComponentLimitListQuery();
        this.data = [];
        this.componentTree = null;
        this.componentTypes = [
            { value: null, text: 'All' },
            { value: 2, text: 'Strings' },
            { value: 3, text: 'Blocks' },
            { value: 5, text: 'Sensors' },
            { value: 6, text: 'Modules' },
            { value: 7, text: 'Cell Temperatures' },
            { value: 8, text: 'Terminal Temperatures' }
        ];
    }
    created() {
        this.getCompanies();
        this.getSystems();
        this.getLookups();
    }
    getCompanies() {
        return __awaiter(this, void 0, void 0, function* () {
            this.working = true;
            return yield companiesClient
                .getListGET()
                .then(response => {
                this.companies = (response || []).map((item) => {
                    return {
                        value: item.companyId,
                        text: item.companyName || ""
                    };
                });
                this.companies = [{ value: null, text: 'All companies' }].concat(this.companies);
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        });
    }
    getSystems() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield systemsClient
                .getSystems(false, Feature.ComponentLimit_View)
                .then(response => {
                this.systems = response;
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            });
        });
    }
    getStrings(systemId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!systemId) {
                this.strings = [];
                return;
            }
            this.working = true;
            return yield systemComponentsClient
                .getSystemStrings(systemId)
                .then(response => {
                this.strings = response;
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        });
    }
    getComponents(systemId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!systemId) {
                this.components = [];
                this.componentTree = null;
                return;
            }
            this.working = true;
            try {
                // Fetch both the flat list and the tree structure
                const [componentsResponse, treeResponse] = yield Promise.all([
                    systemComponentsClient.getSystemComponents(systemId),
                    systemComponentTreeNodesClient.getSystemLocations(systemId)
                ]);
                this.components = componentsResponse;
                this.componentTree = treeResponse;
            }
            catch (ex) {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            }
            finally {
                this.working = false;
            }
        });
    }
    getLookups() {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all([
                alarmsClient
                    .getAlarmTypes()
                    .then(response => {
                    this.alarmTypes = [{ value: null, text: 'All alarm types', measurementTypeId: null, stringStatusId: null }].concat(response
                        .sort((a, b) => (a.alarmTypeName || "").localeCompare(b.alarmTypeName || ""))
                        .map(item => ({
                        value: item.alarmTypeId,
                        text: item.alarmTypeName || "",
                        measurementTypeId: item.measurementTypeId || null,
                        stringStatusId: item.stringStatusId || null
                    })));
                })
                    .catch(ex => {
                    HttpHelper.handleResponse(ex, () => {
                        Notifier.onServerError(ex);
                    });
                }),
                lookupsClient
                    .getMeasurementTypes()
                    .then(response => {
                    this.measurementTypes = [{ value: null, text: 'All measurement types' }].concat(response
                        .sort((a, b) => (a.measurementTypeName || "").localeCompare(b.measurementTypeName || ""))
                        .map(item => ({
                        value: item.measurementTypeId,
                        text: item.measurementTypeName || ""
                    })));
                })
                    .catch(ex => {
                    HttpHelper.handleResponse(ex, () => {
                        Notifier.onServerError(ex);
                    });
                }),
                lookupsClient
                    .getStringStates()
                    .then(response => {
                    this.stringStates = [{ value: null, text: 'All string states' }].concat(response.map(item => ({
                        value: item.statusId,
                        text: item.statusName || ""
                    })));
                })
                    .catch(ex => {
                    HttpHelper.handleResponse(ex, () => {
                        Notifier.onServerError(ex);
                    });
                })
            ]);
        });
    }
    search() {
        if (this.working)
            return;
        if (!this.query.systemId) {
            Notifier.onWarning('Please select a system!');
            return;
        }
        this.working = true;
        componentLimitsClient
            .getComponentLimitList(this.query)
            .then((response) => {
            this.data = response;
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
            this.searchAttempted = true;
        });
    }
    resetFilters() {
        this.query = new GetComponentLimitListQuery();
        this.strings = [];
        this.components = [];
        this.data = [];
        this.searchAttempted = false;
    }
    onCompanyIdChanged() {
        this.query.systemId = 0;
        this.query.stringId = null;
        this.query.componentId = null;
        this.query.componentTypeId = null;
        this.strings = [];
        this.components = [];
    }
    onSystemIdChanged(newVal) {
        return __awaiter(this, void 0, void 0, function* () {
            this.query.stringId = null;
            this.query.componentId = null;
            this.query.componentTypeId = null;
            this.strings = [];
            this.components = [];
            if (newVal) {
                yield this.getStrings(newVal);
                yield this.getComponents(newVal);
            }
        });
    }
    onStringIdChanged() {
        this.query.componentId = null;
        this.query.componentTypeId = null;
    }
    onComponentTypeChanged() {
        this.query.componentId = null;
    }
    onMeasurementTypeChanged() {
        // Reset alarm type when measurement type changes
        this.query.alarmTypeId = null;
    }
    onStringStateChanged() {
        // Reset alarm type when string state changes
        this.query.alarmTypeId = null;
    }
    get companyId() {
        return this.companies.filter(item => {
            return item.value == this.query.companyId;
        })[0] || null;
    }
    set companyId(item) {
        if (!item)
            return;
        this.query.companyId = item.value;
    }
    get systemsFiltered() {
        let filteredSystems = this.systems.filter(system => this.query.companyId == null || this.query.companyId == system.companyId);
        return filteredSystems.map(item => {
            return {
                value: item.systemId,
                text: item.displayName || item.systemName || ""
            };
        });
    }
    get systemId() {
        return this.systemsFiltered.filter(item => {
            return item.value == this.query.systemId;
        })[0] || null;
    }
    set systemId(item) {
        if (!item)
            return;
        this.query.systemId = item.value;
    }
    get stringsFiltered() {
        let strings = (this.strings || []).map(item => {
            return {
                value: item.componentId,
                text: item.componentName || ""
            };
        });
        return [{ value: null, text: 'All strings' }].concat(strings);
    }
    get stringId() {
        return this.stringsFiltered.filter(item => {
            return item.value == this.query.stringId;
        })[0] || null;
    }
    set stringId(item) {
        if (!item)
            return;
        this.query.stringId = item.value;
    }
    get componentTypeId() {
        return this.componentTypes.filter(item => {
            return item.value == this.query.componentTypeId;
        })[0] || null;
    }
    set componentTypeId(item) {
        if (!item)
            return;
        this.query.componentTypeId = item.value;
    }
    get componentsFiltered() {
        if (!this.query.componentTypeId && this.query.componentTypeId !== null) {
            return [];
        }
        let filtered = this.components.filter(comp => {
            // Filter by string if selected
            if (this.query.stringId) {
                // Check if component belongs to the selected string using the tree structure
                if (!this.isComponentInString(comp.componentId, this.query.stringId)) {
                    return false;
                }
            }
            // Filter by component type
            if (this.query.componentTypeId === null) {
                // All types
                return true;
            }
            else {
                return comp.componentTypeId === this.query.componentTypeId;
            }
        });
        let components = filtered.map(item => {
            return {
                value: item.componentId,
                text: item.componentName || ""
            };
        });
        return [{ value: null, text: 'All components' }].concat(components);
    }
    /**
     * Helper method to check if a component belongs to a specific string
     * by traversing the component tree
     */
    isComponentInString(componentId, stringId) {
        if (!this.componentTree || !this.componentTree.children) {
            return false;
        }
        // Find the string in the tree
        const stringNode = this.componentTree.children.find(c => c.componentId === stringId);
        if (!stringNode) {
            return false;
        }
        // If the component is the string itself
        if (componentId === stringId) {
            return true;
        }
        // Recursively search for the component in the string's children
        return this.searchInChildren(stringNode, componentId);
    }
    /**
     * Recursively search for a component in the children tree
     */
    searchInChildren(node, targetComponentId) {
        if (node.componentId === targetComponentId) {
            return true;
        }
        if (node.children && node.children.length > 0) {
            for (const child of node.children) {
                if (this.searchInChildren(child, targetComponentId)) {
                    return true;
                }
            }
        }
        return false;
    }
    get alarmTypesFiltered() {
        // Filter alarm types by selected measurement type and string status
        let filtered = this.alarmTypes.filter(alarmType => {
            // Always show "All alarm types" option
            if (alarmType.value === null) {
                return true;
            }
            // Check measurement type filter
            let measurementTypeMatches = true;
            if (this.query.measurementTypeId) {
                // Show alarm types that match the selected measurement type
                measurementTypeMatches = alarmType.measurementTypeId !== null &&
                    alarmType.measurementTypeId === this.query.measurementTypeId;
            }
            // Check string status filter
            let stringStatusMatches = true;
            if (this.query.stringStateId) {
                // Show alarm types that match the selected string status
                stringStatusMatches = alarmType.stringStatusId !== null &&
                    alarmType.stringStatusId === this.query.stringStateId;
            }
            // Both conditions must be true
            return measurementTypeMatches && stringStatusMatches;
        });
        return filtered;
    }
    get componentId() {
        return this.componentsFiltered.filter(item => {
            return item.value == this.query.componentId;
        })[0] || null;
    }
    set componentId(item) {
        if (!item)
            return;
        this.query.componentId = item.value;
    }
    get alarmTypeId() {
        return this.alarmTypesFiltered.filter(item => {
            return item.value == this.query.alarmTypeId;
        })[0] || null;
    }
    set alarmTypeId(item) {
        if (!item)
            return;
        this.query.alarmTypeId = item.value;
    }
    get measurementTypeId() {
        return this.measurementTypes.filter(item => {
            return item.value == this.query.measurementTypeId;
        })[0] || null;
    }
    set measurementTypeId(item) {
        if (!item)
            return;
        this.query.measurementTypeId = item.value;
    }
    get stringStateId() {
        return this.stringStates.filter(item => {
            return item.value == this.query.stringStateId;
        })[0] || null;
    }
    set stringStateId(item) {
        if (!item)
            return;
        this.query.stringStateId = item.value;
    }
    get noData() {
        return this.searchAttempted && (!this.data || !this.data.length);
    }
    getDateFormated(date) {
        if (!date)
            return "";
        return moment(date).format("DD MMM YYYY HH:mm");
    }
    formatLimit(value) {
        if (value === null || value === undefined)
            return "-";
        return value.toFixed(2);
    }
};
__decorate([
    Watch("query.companyId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ComponentLimitsVue.prototype, "onCompanyIdChanged", null);
__decorate([
    Watch("query.systemId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", typeof (_a = typeof Promise !== "undefined" && Promise) === "function" ? _a : Object)
], ComponentLimitsVue.prototype, "onSystemIdChanged", null);
__decorate([
    Watch("query.stringId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ComponentLimitsVue.prototype, "onStringIdChanged", null);
__decorate([
    Watch("query.componentTypeId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ComponentLimitsVue.prototype, "onComponentTypeChanged", null);
__decorate([
    Watch("query.measurementTypeId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ComponentLimitsVue.prototype, "onMeasurementTypeChanged", null);
__decorate([
    Watch("query.stringStateId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ComponentLimitsVue.prototype, "onStringStateChanged", null);
ComponentLimitsVue = __decorate([
    Component({
        name: "ComponentLimitsVue"
    })
], ComponentLimitsVue);
export default ComponentLimitsVue;
